import { render, staticRenderFns } from "./manage-booking-modal-email-receipt.vue?vue&type=template&id=45d69708&scoped=true"
import script from "./manage-booking-modal-email-receipt.vue?vue&type=script&lang=ts"
export * from "./manage-booking-modal-email-receipt.vue?vue&type=script&lang=ts"
import style0 from "./manage-booking-modal-email-receipt.vue?vue&type=style&index=0&id=45d69708&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d69708",
  null
  
)

export default component.exports